import { CSSProperties, PropsWithChildren } from "react";

import { ClassNameMap } from "@mui/styles";

import { InternalClasses } from "../helpers";

import { NonGenericBaseFormFieldProps } from "@/common/types/baseFormField";
import { InputVibe } from "@/common/types/mui";

export type OptionGroupLabelBaseClasses =
  | "container"
  | "labelSection"
  | "labelForm"
  | "labelNeutral"
  | "labelError"
  | "disabledLabel"
  | "tooltip"
  | "error"
  | "helperText";

const PREFIX = "OptionGroupLabel";

export const zeffyOptionGroupLabelClasses: InternalClasses<typeof PREFIX, OptionGroupLabelBaseClasses> = {
  container: `${PREFIX}-container`,
  labelSection: `${PREFIX}-labelSection`,
  labelForm: `${PREFIX}-labelForm`,
  labelNeutral: `${PREFIX}-labelNeutral`,
  labelError: `${PREFIX}-labelError`,
  tooltip: `${PREFIX}-tooltip`,
  disabledLabel: `${PREFIX}-disabledLabel`,
  error: `${PREFIX}-error`,
  helperText: `${PREFIX}-helperText`,
};

export interface OptionGroupLabelProps
  extends
    Pick<NonGenericBaseFormFieldProps, "error" | "errorMessage" | "label" | "data-test">,
    PropsWithChildren<unknown> {
  classes?: Partial<ClassNameMap<OptionGroupLabelBaseClasses>>;
  className?: string;
  vibe?: InputVibe;
  disabled?: boolean;
  helperText?: NonGenericBaseFormFieldProps["label"];
  tooltipText?: string;
  style?: CSSProperties;
}

export type OptionGroupLabelSsrProps = OptionGroupLabelProps & {
  forwardedRef?: React.Ref<HTMLDivElement>;
};
